function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a31ac3af-16a9-4814-a9d0-9f21203bf135",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "b3ec0e7a-2ba6-41c9-bc64-0d290545fcc5",
    "data-name": "Wave-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "acc9a8ad-d9e5-4dab-a31a-19aec6c520bc",
    "data-name": "Rectangle",
    d: "M0,0C722,0,722,66.56677,1366,41.9925V48H0Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave5;